import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import NewService from '../../service/newService';
import { Col, Row, Button, Table } from 'reactstrap';
import { Body, Cantainer, Head, TagFilas } from './style';
import Modal from '../../../../components/Modal/DefaultModal';
import { ModalUpdate } from './Modal/ModalUpdate';
import { ModalCreate } from './Modal/ModalCreate';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import getFlexIAType from 'views/FlexIA/utils/getFlexIAType';
import FlexIAService from '../../../FlexIA/service';

const Timeout = () => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [timeoutConfigs, setTimeoutConfigs] = useState({});
  const [modalUpdateExist, setModalUpdateExist] = useState(false);
  const [isModalCreateOpen, setIsModalCreateOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [flexias, setFlexias] = useState([]);

  useEffect(() => {
    FlexIAService.getAllFlexia(1, 100, '', { showDisable: false })
      .then((response) => {
        setFlexias(
          response.data.result.map((flexia) => {
            return {
              ...flexia,
              optionSubtitle: getFlexIAType(flexia.type || '')
            };
          })
        );
      })
      .catch((err) => {
        toast.error(
          (err.response && err.response.data.message) ||
            'Erro ao listar configurações da FlexIA!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      });
  }, []);

  const timeoutPadrao = {
    typeOfAttendant: 'Atendente',
    timeoutClosing: 1,
    active: false,
    action: 'encerrar',
    inTheQueues: [],
    transferQueue: '',
    ignoreWeekend: true,
    closingMessage: '',
    reminderMessage: '',
    channels: [],
    // Os parametros abaixo podem estar sendo usados em outras APIs
    timeoutMsgEncerramento: 1,
    timeoutMsgLembrete: 1,
    timeout: 1
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    NewService.getTimeOut().then((response) => {
      setTimeoutConfigs(response.data.result);
    });
  }, []);

  function controlToggleActive(id) {
    const filteredTimeout = timeoutConfigs.filter(
      (timeout) => timeout.id === id
    )[0];

    setTimeoutConfigs(
      timeoutConfigs.map((timeout) => {
        if (timeout.id === id) {
          return {
            ...timeout,
            active: !timeout?.active
          };
        }
        return timeout;
      })
    );

    NewService.changeStatusTimeout(filteredTimeout.id)
      .then((response) => {
        if (response.data) {
          toast.success(
            !filteredTimeout.active
              ? 'Configuração de inatividade ativada'
              : 'Configuração de inatividade desativada',
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data || 'Ops, ocorreu um erro', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });
  }
  function handleModalCreate() {
    setIsModalCreateOpen(true);
    setIsModalOpen(true);
  }

  function modifyStateModal(boll) {
    setIsModalOpen(boll);
  }
  function handleGetTimeout(id) {
    setModalUpdateExist(timeoutConfigs[id]);
    setIsModalCreateOpen(false);
    setIsModalOpen(true);
  }

  function handleDeleteTimeout(id) {
    const filteredTimeout = timeoutConfigs.filter(
      (timeout) => timeout.id == id
    );
    NewService.deleteTimeout(filteredTimeout[0].id)
      .then((response) => {
        if (response.data) {
          toast.success('Configuração excluída com sucesso', {
            autoClose: 3000,
            closeOnClick: true
          });

          setTimeoutConfigs(
            timeoutConfigs.filter((timeout) => timeout.id !== id)
          );
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error('Ops, ocorreu um erro!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      });
  }

  return (
    <>
      <Cantainer color={systemConfiguration.primary_color}>
        <Row className="mb-5 mt-2">
          <Col md="12">
            <Button
              name="create"
              color="primary"
              size="sm"
              title={'Adicionar timeout'}
              onClick={() => {
                handleModalCreate();
                toggleModal();
              }}
            >
              <li className="fas fa-plus"></li> Adicionar timeout
            </Button>
          </Col>
        </Row>
        {timeoutConfigs ? (
          <>
            <Row>
              <Table>
                <Head>
                  <tr>
                    <th>REGRA</th>
                    <th>AÇÃO</th>
                    <th>ORIGEM</th>
                    <th>CANAL</th>
                    <th>TEMPO</th>
                    <th>ATIVO</th>
                    <th>Editar/Excluir</th>
                  </tr>
                </Head>
                <Body>
                  <Modal
                    show={isModalOpen}
                    onModalToggle={(state) => setIsModalOpen(state)}
                    title="Regra de Inatividade"
                    showCloseButton={false}
                    size="xl"
                  >
                    {isModalCreateOpen ? (
                      <ModalCreate
                        info={timeoutPadrao}
                        modifyStateModal={modifyStateModal}
                        setTimeoutConfigs={setTimeoutConfigs}
                        timeoutConfigs={timeoutConfigs}
                        flexias={flexias}
                      />
                    ) : (
                      <ModalUpdate
                        info={modalUpdateExist}
                        modifyStateModal={modifyStateModal}
                        setTimeoutConfigs={setTimeoutConfigs}
                        timeoutConfigs={timeoutConfigs}
                        flexias={flexias}
                      />
                    )}
                  </Modal>

                  {timeoutConfigs.length > 0 &&
                    timeoutConfigs.map((item, index) => {
                      let action = '';
                      switch (item.action) {
                        case 'encerrar':
                          action = 'Encerrar';
                          break;
                        case 'transferir':
                          action = 'Transferir';
                          break;
                        case 'transferir_para_fila_do_no':
                          action = 'Transferir para fila do nó';
                          break;

                        default:
                          break;
                      }

                      let sources = [];
                      switch (item.typeOfAttendant) {
                        case 'Atendente':
                          sources = item?.inTheQueues?.map((q, index) => (
                            <TagFilas key={index}>{q}</TagFilas>
                          ));
                          break;
                        case 'FlexIA':
                          sources = item?.inTheFlexIAs?.map((id, index) => (
                            <TagFilas key={index}>
                              {
                                flexias?.find((flexia) => flexia.id === id)
                                  ?.name
                              }
                            </TagFilas>
                          ));
                          break;
                      }

                      return (
                        <>
                          <tr key={index}>
                            <td>{item.typeOfAttendant}</td>
                            <td>{action}</td>
                            <td>{sources}</td>
                            <td>
                              {item?.channels?.map((q, index) => (
                                <TagFilas key={index}>{q}</TagFilas>
                              ))}
                            </td>
                            <td>
                              {item.timeoutClosing || item.timeout} minuto(s)
                            </td>
                            <td>
                              <ToggleSwitch
                                checked={item.active}
                                id={index}
                                onChange={() => controlToggleActive(item?.id)}
                              />
                            </td>

                            <td>
                              <div>
                                <Button
                                  color="info"
                                  size="sm"
                                  title={'Editar timeout'}
                                  onClick={() => {
                                    handleGetTimeout(index);
                                    toggleModal();
                                  }}
                                >
                                  <li className="fas fa-edit"></li>
                                </Button>

                                <Button
                                  color="danger"
                                  size="sm"
                                  title={'Excluir timeout'}
                                  onClick={() => {
                                    window.confirm(
                                      'Deseja realmente excluir essa configuração?'
                                    ) && handleDeleteTimeout(item.id);
                                  }}
                                >
                                  <li className="fas fa-trash"></li>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </Body>
              </Table>
            </Row>

            <hr
              style={{
                color: '#eee',
                backgroundColor: '#eee',
                height: 0.5,
                borderColor: '#eee'
              }}
            />
          </>
        ) : (
          'Adicionar configuração de inatividade'
        )}
      </Cantainer>
    </>
  );
};

export { Timeout };
